import React, { Component } from 'react';
import { Modal, Steps, Button, message } from 'antd';
const Step = Steps.Step;

class PlateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {step: 0, stepLimit: 0, validation: false, plate: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleNumber = this.handleNumber.bind(this);
    this.handleNotes = this.handleNotes.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.state.validation)
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.plate);
      this.setState({validation: true, plate: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  handleNumber(event) {
    this.setProp('number', event.target.value);
    this.setState({validation: true});
  }

  handleNotes(event) {
    this.setProp('notes', event.target.value);
    this.setState({validation: true});
  }

  setProp(prop, value) {
    const record = this.state.plate;
    record[prop] = value;

    this.setState({plate: record});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Número de placas" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Número de placas</label>
              <input type="text" className="form-control" defaultValue={this.props.current.name} placeholder="GTA01" onChange={this.handleNumber} />
            </div>

            <div className="form-group">
              <label>Notas</label>
              <input type="text" className="form-control" defaultValue={this.props.current.notes} placeholder="Notas" onChange={this.handleNotes} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default PlateModal;



// WEBPACK FOOTER //
// ./src/components/modals/PlateModal.js